export const STORY_TYPES = 'STORY_TYPES';
export const STORIES = 'STORIES';
export const STORY_BY_ID = 'STORY_BY_ID';
export const DELETED_STORIES = 'DELETED_STORIES';
export const STORY_WITH_OUT_LIMIT = 'STORY_WITH_OUT_LIMIT';
